/** Advisory input validation only. Recipient identity and consent are always checked by the server. */
export function normalizeInvitationEmail(raw: string): string | undefined {
  if (raw.length > 512) return undefined;
  const value = raw.trim().toLowerCase();
  const local = value.slice(0, value.indexOf("@"));
  if (value.length < 3 || value.length > 254 || local.length > 64 || local.startsWith(".") || local.endsWith(".") || local.includes("..") || /[\u0000-\u001f\u007f-\u009f]/.test(value)) return undefined;
  return /^[^\s@<>(),;:"\\]+@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(value) ? value : undefined;
}
